import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/6u4lcqyl_Logo%20Boucherie%20Costa.png";

export default function Logo({ size = "md", withText = false, className = "", href = "/" }) {
    const sizes = { sm: "h-10", md: "h-14", lg: "h-20", xl: "h-28" };
    const cls = sizes[size] || sizes.md;
    const content = (
        <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
            <img
                src={LOGO_URL}
                alt="Boucherie Costa"
                className={`${cls} w-auto object-contain`}
                draggable={false}
            />
        </div>
    );
    if (!href) return content;
    return (
        <Link to={href} className="inline-flex" data-testid="brand-logo-link">
            {content}
        </Link>
    );
}
